module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/modal//modal-confirm.png?v=b06dfd9a";